var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('user-menu'),_c('verify-permission',{attrs:{"controller":"Reportes","action":"getTotalPedidosByStatus"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.dashboard.title'),
            icon: 'now-ui-icons design_app',
            path: '/dashboard'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('app.nav_bar.admin.users_permissions'),
          icon: 'el-icon-user'
        }}},[_c('verify-permission',{attrs:{"controller":"Roles","action":"getAllRoles"}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Roles',
              path: '/admin/roles'
            }}})],1),_c('verify-permission',{attrs:{"controller":"Usuarios","action":"getUsuarios"}},[_c('sidebar-item',{attrs:{"link":{
              name: this.$t('app.modules.users.title'),
              icon: 'now-ui-icons users_single-02',
              path: '/admin/usuarios'
            }}})],1),_c('verify-permission',{attrs:{"controller":"UsuarioTransportista","action":"getUsuariosTransportistas"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.transport_users.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/usuarios_transportistas'
            }}})],1),_c('verify-permission',{attrs:{"controller":"Organizaciones","action":"listaOrganizaciones"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.organizations.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/organizaciones'
            }}})],1)],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('app.nav_bar.admin.setting'),
          icon: 'el-icon-setting'
        }}},[_c('verify-permission',{attrs:{"controller":"MailConfiguration","action":"getMailConfiguration"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.mail_configuration.title'),
              icon: 'now-ui-icons files_box',
              path: '/admin/configuracion_email'
            }}})],1),_c('verify-permission',{attrs:{"controller":"HorarioIngresoPedido","action":"getHorarioIngresoPedido"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.order_entry_schedule.title'),
              icon: 'el-icon-alarm-clock',
              path: '/admin/horario_ingreso'
            }}})],1),_c('verify-permission',{attrs:{"controller":"GrupoConfiguracionFasesEntrega","action":"getConfigFasesDeEntrega"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.deliveryPhases.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/delivery_phases'
            }}})],1),_c('verify-permission',{attrs:{"controller":"UsuarioServicioCliente","action":"getAllUSC"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.sac_mapping_settings.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/configuracion_asignaciones_sac'
            }}})],1),_c('verify-permission',{attrs:{"controller":"UsuarioLogistica","action":"getAllUsuariosLogistica"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.logitic_mapping_settings.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/configuracion_asignaciones_logistica'
            }}})],1)],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('app.nav_bar.admin.catalogs'),
          icon: 'now-ui-icons education_agenda-bookmark'
        }}},[_c('verify-permission',{attrs:{"controller":"CategoriaProducto","action":"getCategoria"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.category_product.title'),
              icon: 'now-ui-icons shopping_tag-content',
              path: '/admin/categorias'
            }}})],1),_c('verify-permission',{attrs:{"controller":"Subcategoria","action":"getSubcategoria"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.subcategory_product.title'),
              icon: 'now-ui-icons shopping_tag-content',
              path: '/admin/subcategorias'
            }}})],1),_c('verify-permission',{attrs:{"controller":"CaracteristicasProducto","action":"getCaratacteristicasProducto"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.product_feature.title'),
              icon: 'now-ui-icons business_briefcase-24',
              path: '/admin/caracteristicas_producto'
            }}})],1),_c('verify-permission',{attrs:{"controller":"TipoDocumentoPedido","action":"getTipoDocumentoPedido"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.documentTypes.title'),
              icon: 'now-ui-icons files_single-copy-04',
              path: '/admin/tipos_documentos'
            }}})],1),_c('verify-permission',{attrs:{"controller":"EmpresaTransportista","action":"getEmpresasTransportistas"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.transport_company.title'),
              icon: 'now-ui-icons files_single-copy-04',
              path: '/admin/empresas_transportistas'
            }}})],1),_c('verify-permission',{attrs:{"controller":"DeclinacionPedido","action":"getDeclinacionPedido"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.reasons_declining_order.title'),
              icon: 'el-icon-document-checked',
              path: '/admin/motivos_declinacion'
            }}})],1),_c('verify-permission',{attrs:{"controller":"PropiedadFamiliaProducto","action":"getPropiedadFamiliaProducto"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.product_family_prop.title'),
              icon: 'now-ui-icons business_briefcase-24',
              path: '/admin/propiedades_familias_producto'
            }}})],1),_c('verify-permission',{attrs:{"controller":"Incidencia","action":"getTiposIncidencias"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.incidents.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/tipos_incidencias'
            }}})],1),_c('verify-permission',{attrs:{"controller":"TiposMotivoRechazo","action":"getMotivosRechazoPartida"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.return_catalog.title'),
              icon: 'now-ui-icons shopping_delivery-fast',
              path: '/admin/motivivos_devolucion'
            }}})],1)],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('app.nav_bar.admin.reports'),
          icon: 'now-ui-icons education_paper'
        }}},[_c('verify-permission',{attrs:{"controller":"Pedidos","action":"ListaPedidos"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.orders.title'),
              icon: 'now-ui-icons design-2_ruler-pencil',
              path: '/admin/reporte_pedidos'
            }}})],1),_c('verify-permission',{attrs:{"controller":"Reclamaciones","action":"getReclamaciones"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.complaints.title'),
              icon: 'now-ui-icons design-2_ruler-pencil',
              path: '/admin/reporte_reclamaciones'
            }}})],1),_c('verify-permission',{attrs:{"controller":"Cotizacion","action":"listaCotizaciones"}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('app.modules.quotes.title'),
              icon: 'now-ui-icons design-2_ruler-pencil',
              path: '/admin/reporte_cotizaciones'
            }}})],1)],1),_c('verify-permission',{attrs:{"controller":"Prospectos","action":"getProspectos"}},[_c('sidebar-item',{attrs:{"link":{
            name: this.$t('app.modules.candidates.title'),
            icon: 'el-icon-suitcase',
            path: '/admin/prospectos'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Comunicaciones","action":"getComunicaciones"}},[_c('sidebar-item',{attrs:{"link":{
            name: this.$t('app.modules.messages.title'),
            icon: 'now-ui-icons education_paper',
            path: '/admin/comunicados'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Reclamaciones","action":"getReclamaciones"}},[_c('sidebar-item',{attrs:{"link":{
            name: this.$t('app.modules.complaints.title'),
            icon: 'el-icon-edit',
            path: '/admin/reclamaciones'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Pedidos","action":"ListaPedidos"}},[_c('sidebar-item',{attrs:{"link":{
            name: this.$t('app.modules.orders.title'),
            icon: 'el-icon-box',
            path: '/admin/pedidos'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Productos","action":"getAllProductos"}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Productos',
            icon: 'now-ui-icons files_paper',
            path: '/admin/productos'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Clientes","action":"getListadoClientesSAP"}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Clientes',
            icon: 'now-ui-icons business_briefcase-24',
            path: '/admin/clientes'
          }}})],1),_c('verify-permission',{attrs:{"controller":"FamiliasProducto","action":"getFamiliasProducto"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.product_family.title'),
            icon: 'now-ui-icons shopping_tag-content',
            path: '/admin/familia_producto'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Pedidos","action":"ListaPedidoPorTransportista"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.delivery.title'),
            icon: 'el-icon-truck',
            path: '/admin/entregas'
          }}})],1),_c('verify-permission',{attrs:{"controller":"WebServiceTransportistas","action":"addTracking"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.develop.title'),
            icon: 'el-icon-setting',
            path: '/admin/desarrollador'
          }}})],1),_c('verify-permission',{attrs:{"controller":"WebServiceTransportistas","action":"addTracking"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.check_order_tracking.title'),
            icon: 'now-ui-icons files_paper',
            path: '/admin/consulta_tracking_pedidos'
          }}})],1),_c('verify-permission',{attrs:{"controller":"Cotizacion","action":"listaCotizacionesByVendedor"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.quotes.title'),
            icon: 'el-icon-postcard',
            path: '/admin/cotizaciones'
          }}})],1),_c('verify-permission',{attrs:{"controller":"CompraRapida","action":"postEnviarInvitaciones"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.fast_ shopping.title'),
            icon: 'el-icon-shopping-cart-full',
            path: '/admin/compra_rapida'
          }}})],1),_c('verify-permission',{attrs:{"controller":"EntregasOperadores","action":"ListaEntregasOperador"}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('app.modules.operator_deliveries.title'),
            icon: 'el-icon-s-check',
            path: '/admin/entregas_operador'
          }}})],1)],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1),_c('push-notification-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }